import { render, staticRenderFns } from "./TriviaHard.vue?vue&type=template&id=247790c3&scoped=true&"
import script from "./TriviaHard.vue?vue&type=script&lang=js&"
export * from "./TriviaHard.vue?vue&type=script&lang=js&"
import style0 from "./TriviaHard.vue?vue&type=style&index=0&id=247790c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247790c3",
  null
  
)

export default component.exports